import Vue from "vue";

export default {
    warning(message) {
        Vue.notify({
            group: "notification",
            type: "warn",
            title:
                "<i class='icon-warning'></i>Warning<i class='icon-close'></i>",
            text: message,
            speed: 500,
            duration: 5000
        });
    },
};
